import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getLoanLessHundreadURL } from "../utils/constants/apiEndPoints";
import { showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";
import privateAxios from "../utils/axiosPrivate";
import { commonErrMsg } from "../locales/en";

const initialState = {
  loading: false
};

const loanLessHundreadSlice = createSlice({
  name: "loanLessHundred",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLoanLessHundreadThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLoanLessHundreadThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getLoanLessHundreadThunk.rejected, (state, action) => {
        state.loading = false;
        const error = action.payload;

        const errorMessage =
          error?.response?.data?.errors?.[0] ||
          error?.response?.data?.message ||
          error?.message ||
          commonErrMsg.item2;

        showToast(errorMessage, showToastType.error);
      });
  }
});

// Define thunk AFTER the slice (following your working email template pattern)
export const getLoanLessHundreadThunk = createAsyncThunk(
  "loanLessHundred/getLoanLessHundreadThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getLoanLessHundreadURL, {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default loanLessHundreadSlice.reducer;
